import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateRestrictionSchemaPayload } from "../schema/UpdateRestrictionSchema";
import UpdateRestrictionResponse from "../response/UpdateRestrictionResponse";

const API_VERSION = 'v4';

export const useUpdateRestriction = () => {
    return useMutation({
        mutationFn: async (data: {
            values: UpdateRestrictionSchemaPayload;
        }) => privateApi.post(`/${API_VERSION}/update-restriction`, data.values),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateRestrictionResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update restriction data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update restriction', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid restriction data format");
            } else {
                console.error('Failed to update restriction', error);
                throw error;
            }
        },
    });
};